import {isEmpty} from "../../appHelper";

export interface Location {
  locationId: number;
  companyId: number;
  companyName: string;
  address: string;
  latitude: number
  longitude: number
}

export interface LocationListResponse {
  responseCode: string;
  locations: Location[];
  locationCount: number
}

export interface AddLocationRequest {
  companyId: number;
  address: string;
  longitude: number;
  latitude: number;
}

export const initialAddLocationRequest: AddLocationRequest = {
  companyId: -1,
  address: "",
  longitude: 47.530519197005376,
  latitude: 19.034884013536047,
};

export const isAddLocationRequestValid = (request: AddLocationRequest) => {
  return (
      !isEmpty(request.address) &&
      request.companyId > -1 &&
      request.longitude > -1 &&
      request.latitude > -1
  );
};
